import globalEventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'
import challengesNavigator from '../challenges_navigator.js'
import 'toxilibs/extlibs/jquery.mousewheel.js'

let $selection  = $('#challenge_selection')
let $container  = $('#challenge_selection .container')
let $buttonMenu = $('button.menu')

let buttonMenuIsDisplayed = true

$(document).on('mousewheel click', function () {
    $container.stop()
})

globalEventBus.on('button menu clicked', function () {
    if (buttonMenuIsDisplayed) {
        show()
    }
})

globalEventBus.on('team page hidden', show)

globalEventBus.on('ui resized', arrangeChallengeButtons)

globalEventBus.on('challenges added', init)

globalEventBus.on('challenge selected', hide)
globalEventBus.on('team page displayed', function () {
    hide()
    showButton()
})

globalEventBus.on('wrong way taken', hideButton)
globalEventBus.on('world reset', showButton)

globalEventBus.on('challenge selected', updateCurrent)

globalEventBus.on('step completed', function (step, isLast) {
    if (!isLast) {
        transitionThroughMenu(step)
    }
})

globalEventBus.on('chef wants to display menu', show)

globalEventBus.on('end page hidden', function () {
    show(true)
})


let inTransitionThroughMenu = false

function transitionThroughMenu (step) {
    inTransitionThroughMenu = true
    show()

    let stepId = step.id
    let nextId = challengesNavigator.next ? challengesNavigator.next.id : '-1'
    let doneDom = $('.challenge_block[data-id=' + stepId + ']')
    let nextDom = $('.challenge_block[data-id=' + nextId + ']')

    setTimeout(function () {
        doneDom.addClass('done')
        doneDom.removeClass('locked')
        doneDom.removeClass('current')
        doneDom.html(doneDom.attr('data-index'))

        nextDom.removeClass('locked')
        nextDom.addClass('current')
        nextDom.html(nextDom.attr('data-index'))
    }, 800)

    setTimeout(function () {
        if (challengesNavigator.next) {
            selectChallenge(nextDom)
        }
    }, 1600)

}

function hideButton () {
    buttonMenuIsDisplayed = false
    $buttonMenu.fadeOut(fadeDelay)
}

function showButton () {
    buttonMenuIsDisplayed = true
    $buttonMenu.fadeIn(fadeDelay)
}



const fadeDelay = 500

function hide () {
    $selection.fadeOut(fadeDelay, function () {
        inTransitionThroughMenu = false //FIXME: To avoid a bug
    })
    $('#menu_buttons').hide()
    globalEventBus.emit('menu hidden')
}


function show (immediately) {
    if (immediately) {
        $selection.show()
    } else {
        $selection.fadeIn(fadeDelay)
    }
    $('#menu_buttons').show()
    arrangeChallengeButtons()
    scrollToCurrentChallenge()
    globalEventBus.emit('menu displayed')
}


function init () {
    $buttonMenu.on('click', function (e) {
        e.preventDefault()
        $(this).focusout()
        $(this).blur()
        globalEventBus.emit('button menu clicked', this)
    }) //FIXME
    setChallengeButtons()
}


function setChallengeButtons () {
    $container.html('')

    for (let i = 0; i < challengesNavigator.steps.length; i++) {
        let step = challengesNavigator.steps[i]
        let type = getChallengeStateClass(step)

        let challengeText = i
        if (type === 'locked') {
            challengeText = '<i class="custom_icon icon-lock">&#xe804;</i>'
        }

        let $element = $('<div data-index="' + i + '" data-id="' + step.id + '" class="challenge_block ' + type + '">' + challengeText + '</div>')


        $container.append($element)
    }
}


function arrangeChallengeButtons () {
    let width = $container.width() - 100 // 100 is diameter
    let left
    let top
    let angle = 0
    let wantedDistance = 106
    let period = 0.3

    function getLeft (_angle) {
        return width * (Math.cos(Math.PI + _angle * period) + 1) / 2
    }

    function getTop (_angle) {
        return _angle * 20 + 150 * (Math.sin(_angle * period * 2) + 1) / 2
    }

    function findGoodAngle () {
        let delta = 0
        let d = 0
        let newAngle
        while (d < wantedDistance) {
            delta += 0.05
            newAngle = angle + delta
            let newLeft = getLeft(newAngle)
            let newTop  = getTop(newAngle)
            d = Math.sqrt(Math.pow(newTop - top, 2) + Math.pow(newLeft - left, 2))
        }
        return newAngle
    }

    $('.challenge_block').each(function (i) {

        if (i > 0) {
            angle = findGoodAngle()
        }

        left = getLeft(angle)
        top  = getTop(angle)

        $(this).css({
            left: left + 'px',
            top:  top + 'px'
        })
    })


}


$('#challenge_selection').on('mousedown', function (e) {
    e.preventDefault()
})


$('body').on('click', '.challenge_block:not(.locked)', function (e) {
    e.preventDefault()
    if (!inTransitionThroughMenu) {
        selectChallenge(this)
    }
})


function selectChallenge (challengeDom) {
    let challengeId = $(challengeDom).attr('data-id')

    let challenge = challengesNavigator.getStep(challengeId)
    if (challenge && challengesNavigator.challengeIsUnlocked(challenge)) {
        globalEventBus.emit('challenge selected', challengeId)
    }
}


let scrollDelay = 1000

function scrollToCurrentChallenge () {
    let $current = $('.current')
    if ($current.length === 0) {
        return
    }

    let offset = $current.offset().top + $container.scrollTop()

    offset -= ($selection.height() - $current.height()) / 2

    $container.animate({
        scrollTop: offset
    }, scrollDelay)
}


function updateCurrent () {
    $('.challenge_block').removeClass('current')
    $('.challenge_block[data-id=' + challengesNavigator.current.id + ']').addClass('current')
}


function getChallengeStateClass (challenge) {
    if (challengesNavigator.doneSteps[challenge.id]) {
        return 'done'
    }

    if (challengesNavigator.challengeIsUnlocked(challenge)) {
        return ''
    } else {
        return 'locked'
    }
}

globalEventBus.on('application loaded', init)
